import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
} from '@mui/material';
import { ROWS_PER_PAGE_LIST } from '../../../_constants/Const';
import { formatDate } from '../../../_utils/utils';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { RootState } from '../../../stores/store';
import { TABLE_HEADER } from '../../../_constants/styleConst';

const pCodeTableColumns = [
  { id: 0, width: '10%', label: 'LBL_CODE' },
  { id: 1, width: '11.25%', label: 'LBL_GROUP_CODE' },
  { id: 2, width: '11.25%', label: 'LBL_CODE_NAME' },
  { id: 3, width: '11.25%', label: 'LBL_E_CODE_NAME' },
  { id: 4, width: '11.25%', label: 'LBL_J_CODE_NAME' },
  { id: 5, width: '11.25%', label: 'LBL_CREATE_TIME' },
  { id: 6, width: '11.25%', label: 'LBL_CREATE_USER' },
  { id: 7, width: '11.25%', label: 'LBL_UPDATE_TIME' },
  { id: 8, width: '11.25%', label: 'LBL_UPDATE_USER' },
] as const;

const PCode: React.FC = () => {
  const { t } = useTranslation();

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(ROWS_PER_PAGE_LIST[0]);

  const { pCodeList } = useSelector((state: RootState) => state.codeMaster);

  const { userData } = useSelector((state: RootState) => state.userInfo);

  useEffect(() => {
    setPage(0);
  }, [pCodeList]);

  const handleChangePage = (
    _: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number,
  ) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    setRowsPerPage(Number(event.target.value));
    setPage(0);
  };

  return (
    <Box sx={{ mx: '2%' }}>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              {[...pCodeTableColumns]
                .sort((a, b) => a.id - b.id)
                .map((column, i) => (
                  <TableCell
                    key={`p_code_header_${i}`}
                    sx={{
                      ...TABLE_HEADER,
                      width: column.width,
                      cursor: 'default',
                    }}
                  >
                    {t(column.label)}
                  </TableCell>
                ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {pCodeList
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((code, i) => (
                <TableRow key={`p_code_${i}`} hover>
                  <TableCell>{code.code}</TableCell>
                  <TableCell>{code.groupCode}</TableCell>
                  <TableCell>{code.name}</TableCell>
                  <TableCell>{code.eName}</TableCell>
                  <TableCell>{code.jName}</TableCell>
                  <TableCell>
                    {formatDate(code.createTime, userData.dateFormat)}
                  </TableCell>
                  <TableCell>{code.createUser}</TableCell>
                  <TableCell>
                    {formatDate(code.updateTime, userData.dateFormat)}
                  </TableCell>
                  <TableCell>{code.updateUser}</TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
        <TablePagination
          labelRowsPerPage={t('LBL_ROWS_PER_PAGE')}
          rowsPerPageOptions={ROWS_PER_PAGE_LIST}
          component="div"
          count={pCodeList.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          labelDisplayedRows={({ from, to, count }) =>
            t('LBL_DISPLAY_DATA_LABEL', { 0: from, 1: to, 2: count })
          }
        />
      </TableContainer>
    </Box>
  );
};

export default PCode;
